


"use client";

import { useEffect, useRef, useState } from "react";
import Navbar from "../components/Homapage/Navbar";
import VideoCard from "../components/VideoCard";
import { useTheme } from "@/app/context/ThemeContext";
import Footer from "../components/Homapage/Footer";
import { useLanguage } from "../components/context/LanguageContext";
import Breadcrumb from "../components/Breadcrumb";
import { STRAPI_URL } from "@/lib/strapi";

interface FeaturedImage {
  url: string;
  alternativeText?: string;
}

interface NewsItem {
  id: number;
  title: string;
  slug: string;
  summary: { type: string; children: { text: string }[] }[];
  featuredImage: FeaturedImage[];
}


const translations: any = {
  fr: {
    Title: "Dernières Actualités",
    description1: "Restez informé avec les dernières mises à jour, annonces et perspectives de l'industrie d'ENAP.",
    description2: "News disponibles",
    label1: "Accueil",
    label2: "News",
        Loading: "Chargement ...",

  },

  en: {
    Title: "Latest News",
    description1: "Stay informed with the latest updates, announcements, and industry insights from ENAP.",
    description2: "Available News",
    label1: "Home",
    label2: "News",
        Loading: "Loading ...",

  },

  ar: {
    Title: "آخر الأخبار",
    description1: "ابقَ على اطلاع بأحدث التحديثات والإعلانات ورؤى صناعة ENAP.",
    description2: "الأخبار المتاحة",
    label1: "الرئيسية",
    label2: "الأخبار",
        Loading: "جارٍ تحميل  ...",

  },
};










export default function Newspage() {
  const { theme } = useTheme();
  const { language } = useLanguage();
 // const //STRAPI_URL = process.env.NEXT_PUBLIC_STRAPI_URL;

  const [news, setNews] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const t = translations[language] || translations.en;
 const [loadingg, setLoadingg] = useState(false);
  const [logg, setLogg] = useState<string[]>([]);
  const hasRun = useRef(false); // 🔒 LOCK
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;


  useEffect(() => {
    if (hasRun.current) return; // ⛔ stop duplicates
    hasRun.current = true;

    const processNews = async () => {
      setLoadingg(true);
      setLogg((l) => [...l, "⏳ Starting process..."]);

      try {
        const newsRes = await fetch(
          `${STRAPI_URL}/api/newsses?populate=*`
        );
        const newsData = await newsRes.json();

        const sentNews = newsData.data.filter(
          (news: any) => news.sent === true
        );

        if (sentNews.length === 0) {
          setLogg((l) => [...l, "❌ No news with sent=true"]);
          return;
        }

        setLogg((l) => [...l, `📨 ${sentNews.length} news to send`]);

        const subsRes = await fetch(
          `${process.env.NEXT_PUBLIC_STRAPI_URL}/api/subscribersses?populate=*`
        );
        const subsData = await subsRes.json();
        const subscribers = subsData.data;

        for (const news of sentNews) {
          const title = news.title || "Untitled";
          setLogg((l) => [...l, `➡️ Sending: ${title}`]);

          await fetch("/api/send-news", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ news, subscribers }),
          });

          await fetch("/api/update-news", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ documentId: news.documentId }),
          });

          setLogg((l) => [...l, `✅ Updated: ${title}`]);
          console.log(setLogg)
        }

        setLogg((l) => [...l, "🎉 All news processed successfully"]);
      } catch (err) {
        console.error(err);
        setLogg((l) => [...l, "❌ Error occurred"]);
      } finally {
        setLoadingg(false);
      }
    };

    processNews();
  }, []);


















  useEffect(() => {
    async function fetchNews(lang: string) {
      setLoading(true);
      setError(null);

      try {
        const res = await fetch(
          `${STRAPI_URL}/api/newsses?populate=*&locale=${lang}&sort=id:desc`,
          { cache: "no-store" }
        );
        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);

        const data = await res.json();
        setNews(data.data || []);
      } catch (err) {
        console.error("Error fetching news:", err);
        setError("Unable to load news. Please try again later.");
      } finally {
        setLoading(false);
      }
    }

    fetchNews(language);
  }, [language]);

  // Calculate items to display
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentNews = news.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(news.length / itemsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  if (loading) {
    return (
      <div className={`min-h-screen ${theme === "dark" ? "bg-gray-900" : "bg-gray-50"}`}>
        <Navbar />
        <p className="text-center py-20 text-lg text-gray-500">            {t.Loading}</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`min-h-screen ${theme === "dark" ? "bg-gray-900 text-gray-100" : "bg-gray-50 text-gray-900"}`}>
        <Navbar />
        <div className="pt-24 text-center">
          <p className="text-xl mb-4">{error}</p>
          <button onClick={() => window.location.reload()} className="px-6 py-3 rounded-lg font-medium bg-blue-600 text-white hover:bg-blue-500">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`min-h-screen flex flex-col ${theme === "dark" ? "bg-gray-900 text-gray-100" : "bg-gray-50 text-gray-900"}`}>
      {/*<Navbar />*/}

  <section
  className={`pt-24 pb-20 relative overflow-hidden text-white ${
    theme === "dark"
      ? "bg-gradient-to-r from-gray-800 via-gray-900 to-gray-800"
      : "bg-gradient-to-r from-blue-600 to-purple-700"
  }`}
  style={{
    backgroundImage: theme === "dark" ? undefined : "url('/test.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="relative z-30 max-w-7xl mx-auto px-4 pt-6 text-white">
        <Breadcrumb
           items={[
            { label: t.label1, href: "/" },
            { label: t.label2 },
          ]}
      />
      </div>
   <div className="absolute inset-0 bg-black/50 backdrop-blur-[1px]"></div>

   <div className="max-w-6xl mx-auto px-4 text-center relative z-10">
    <h1 className="text-4xl md:text-5xl font-bold mb-6 drop-shadow-lg">
            {t.Title}
    </h1>

    <p className="text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed drop-shadow">

            {t.description1}
    </p>

     <div className="mt-12 flex flex-wrap justify-center gap-8">
      <div className="text-center">
        <div className="text-3xl font-bold drop-shadow">{news.length}</div>
        <div className="text-sm font-medium text-blue-200">
            {t.description2}
        </div>
      </div>
    </div>
  </div>
</section>







      <section className="py-16 px-4 max-w-7xl mx-auto flex-1">
        {currentNews.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {currentNews.map((item) => {
              const imageUrl = item.featuredImage[0]?.url
                ? `${STRAPI_URL}${item.featuredImage[0].url}`
                : "/video.png";
              const category = item.summary[0]?.children[0]?.text || "Sans catégorie";

              return (
                <VideoCard
                  key={item.id}
                  title={item.title}
                  category={category}
                  tag={item.slug}
                  image={imageUrl}
                  link={`/news/${item.slug}`}
                />
              );
            })}
          </div>
        ) : (
          <div className="text-center py-16">
            <h3 className="text-xl font-semibold mb-2">Aucune nouveaux disponible</h3>
            <p>Revenez bientôt pour découvrir nos nouveaux contenus .</p>
          </div>
        )}

        {/* Pagination buttons */}
        {news.length > itemsPerPage && (
          <div className="flex justify-center mt-8 gap-4">
            <button
              onClick={handlePrev}
              disabled={currentPage === 1}
              className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50 hover:bg-gray-400"
            >
              Prev
            </button>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50 hover:bg-gray-400"
            >
              Next
            </button>
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
}






























 